import client from './client';

const eqpUrl = '/api/v1/eqp';

// ============================= 가공 진행 화면(공구 경로) =============================
// 장비 상세 "가공 진행" 탭 + 모니터링 보드 썸네일. 계획: 설비모니터링/가공 진행 화면(공구 경로) 계획.md.
//
// 주의: progress 응답은 eqpMagazine.js/eqpToolLife.js 와 달리 {info: {...}} 로 감싸지 않고
// EqpToolpathProgressDto 를 그대로 내려준다(EqpToolpathController#progress 가
// ResponseEntity<EqpToolpathProgressDto> 를 바로 반환함) - extractProgress 는 res.data 를 그대로 꺼낸다.

export const getToolpathProgress = (eqpUuid) =>
  client.get(`${eqpUrl}/${eqpUuid}/toolpath/progress`);

export const extractProgress = (res) => res?.data ?? null;

// 이미지는 로그인(Authorization 헤더)이 필요해서 <img src>로 바로 못 띄운다 - axios로 blob을 받아
// URL.createObjectURL로 바꿔서 쓴다(호출한 쪽이 URL.revokeObjectURL로 해제해야 함).
// v는 캐시 무력화용 쿼리(서버가 실제로 어떤 줄을 그릴지는 마지막 progress 결과로 정함).
export const getToolpathImageBlob = (eqpUuid, { w, h, v } = {}) =>
  client.get(`${eqpUrl}/${eqpUuid}/toolpath/image.png`, {
    params: { w, h, v },
    responseType: 'blob',
  });

// 3D 형상 보기(계획: "3D 보기 추가 계획") - 지금까지 깎인 높이 지도. progress와 마찬가지로
// {info: {...}} 로 감싸지 않은 바로(bare) JSON - extractHeightmap은 res.data를 그대로 꺼낸다.
// 응답 모양: { line, nx, ny, xmin, xmax, ymin, ymax, zmin, zmax, stockTop, cutCells,
//            tool: {x,y,z} | null, encoding: "uint16-le-base64", data }
export const getToolpathHeightmap = (eqpUuid, n = 256) =>
  client.get(`${eqpUrl}/${eqpUuid}/toolpath/heightmap`, { params: { n } });

export const extractHeightmap = (res) => res?.data ?? null;
